import React, { useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import Moment from 'react-moment';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
// types
import { stateType } from '../../../../../types/types';
// actions
import groupsAction from '../../../../../redux/actions/groups';
import sessionsAction from '../../../../../redux/actions/sessions';
// components
import SmallGroupCard from '../../../cards/groupCard/SmallGroupCard';
// images
import ImgAfter from '../../../../../assets/image/questions/after.svg';
import { ReactComponent as IconCalendar } from '../../../../../assets/image/dropdown/calendar.svg';
import { ReactComponent as CloseIcon } from '../../../../../assets/image/account/close4.svg';
// style
import './style.scss';

const RestartGroup: React.FC<any> = () => {
  const [visible, setVisible] = useState(false);
  const [success, setSuccess] = useState(false);

  const item = useSelector((state: stateType) => state.groups.item, shallowEqual);
  const loader = useSelector((state: stateType) => state.groups.loaderModal, shallowEqual);

  const open = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onSuccess = () => {
    setSuccess(true);
  };

  return (
    <>
      <button className="btn-form" onClick={open}>
        Restart Group
      </button>
      {visible && (
        <Modal
          visible={visible}
          onOk={handleOk}
          closable={true}
          onCancel={handleCancel}
          centered
          maskTransitionName="none"
          footer={null}
          className="restart-group-modal"
          closeIcon={<CloseIcon />}
        >
          {!success && (
            <Spin spinning={loader}>
              <ModalContainer onSuccess={onSuccess} setVisible={setVisible} item={item} groupID={item.group.id} />
            </Spin>
          )}
          {success && <ModalSuccess handleCancel={handleCancel} item={item} />}
        </Modal>
      )}
    </>
  );
};

export default RestartGroup;

const ModalContainer = ({ onSuccess, item }: any) => {
  const dispatch = useDispatch();

  const action = () => {
    dispatch(groupsAction.restart(item.group.id, onSuccess));
  };

  return (
    <div className="restart-group-container">
      <div className="restart-group-container__title">Are you sure you want to restart the following Group?</div>
      <div className="restart-group-container__main">
        <div className="restart-group-container__group-info">
          <SmallGroupCard item={item} />
        </div>
      </div>
      <div className="restart-group-container__block">
        <button className="btn-form" onClick={action}>
          Confirm
        </button>
      </div>
    </div>
  );
};

const ModalSuccess = ({ handleCancel, item }: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(groupsAction.id(item.group.id));
      dispatch(sessionsAction.get(item.group.id));
    };
  }, []);

  return (
    <div className="restart-group-container">
      <div className="restart-group-container__title restart-group-container__title_success">
        <img className="restart-group-container__finish-icon" src={ImgAfter} alt="Finish icon" />
        <div>You’ve successfully restarted the following Group</div>
      </div>
      <div className="restart-group-container__main">
        <div className="restart-group-container__label">
          <IconCalendar style={{ width: '20px', height: '20px' }} />
          <div className="restart-group-container__date">
            Every  <Moment format={'dddd'}>{item.start}</Moment>
          </div>
        </div>
        <div className="restart-group-container__group-info">
          <SmallGroupCard item={item} />
        </div>
      </div>
      <div className="restart-group-container__block">
        <button className="btn-form" onClick={handleCancel}>
          Done
        </button>
      </div>
    </div>
  );
};
